import request from "./request.js";
import responseHandler from "./ResponseHandlers/AppResponseHandler";
import ShowToast from "@/app/core/components/ToastProvider/ShowToast";
import { error } from "console";
import { useRouter } from "next/router";

export const login = async (reqBody: any) => {
  const res = await request({
    url: `api/authenticate`,
    method: "POST",
    data: reqBody,
    noAlerts: true
  });

  try {
    if (!res || res == undefined || res == null || res == "") {
      throw Error("No Response");
      return null;
    }

    const { message, error, statusCode, data } = res;
    if (error) {
      ShowToast("error", message);
      return null;
    }

    ShowToast("success", "Logged IN");
    window.location.replace("/");
  } catch (error) {
    console.error(error);
    ShowToast("error", "Invalid Credentials");
    return null;
  }

  return null;
};
